import React, { useState, useEffect } from 'react';
import { array, bool, func, object } from 'prop-types';

import { connect } from 'react-redux';

import { orderBy, get } from 'lodash';

import Tooltip from '@material-ui/core/Tooltip';
import LinksTableRowMenu from './LinksTableRowMenu';

import classes from './LinksTable.module.css';
import MaterialTable from 'material-table';

const LinksTable = ({
    contacts,
    links,
    linkType,
    companyInfo,
    isFullArchitectAllowed,
    onToggleDeleteLinkModal,
    onSort,
    order,
    orderBy,
    selectedNode,
    ...props
}) => {

    const [entityType, setEntityType] = useState();

    useEffect(() => {
        if (linkType && linkType.toLowerCase() === 'contact') {
            setEntityType('contact');
            return;
        }

        switch (selectedNode.type) {
            case 'equipmentItem':
                setEntityType('equipment');
                break;
            case 'systemItem':
                setEntityType('system');
                break;
            case 'areaItem':
                setEntityType('area');
                break;
            default:
                setEntityType(selectedNode.type);
                break;
        }
    }, [selectedNode]);

    const renderTypeCell = link => {
        const agentConfigurationId = get(link, 'agentConfigurationId', '');
        const serviceIntegrationName = get(link, 'serviceIntegrationName', 'External Integration');
        const agentConfigurationName = get(link, 'agentConfigurationName', serviceIntegrationName);

        const integrationName = agentConfigurationId ? agentConfigurationName : serviceIntegrationName;

        if (!link.brokenLink) {
            return (
                <React.Fragment>
                    <Tooltip
                        title={
                            <span className={classes.tooltip}>
                                Object Linked
                            </span>
                        }
                        placement="top-start"
                    >
                        <img
                            className={classes.linkedIcons}
                            src="/assets/images/linkedIcon.svg"
                            alt="linked-icon"
                        />
                    </Tooltip>
                    <Tooltip
                        title={
                            <span className={classes.tooltip}>
                                {integrationName}
                            </span>
                        }
                        placement="top-start"
                    >
                        <span className={classes.type}>{integrationName}</span>
                    </Tooltip>
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <Tooltip
                    title={
                        <span className={classes.tooltip}>
                            No Object Linked
                        </span>
                    }
                    placement="top-start"
                >
                    <img
                        className={classes.linkedIcons}
                        src="/assets/images/unlinkedIcon.svg"
                        alt="unlinked-icon"
                    />
                </Tooltip>
                <Tooltip
                    title={
                        <span className={classes.tooltip}>
                            {integrationName}
                        </span>
                    }
                    placement="top-start"
                >
                    <span className={classes.type}>{integrationName}</span>
                </Tooltip>
            </React.Fragment>
        );
    };

    const renderLinkName = rowData => {
        if (rowData.agentConfigurationId) {
            return (
                <React.Fragment>
                    <Tooltip
                        title={
                            <span className={classes.tooltip}>
                                {rowData.name}
                            </span>
                        }
                        placement="top-start"
                    >
                        <span>{rowData.name}</span>
                    </Tooltip>
                </React.Fragment>
            );
        }

        return '-';
    };

    const renderBobEntity = (rowData) => {
        let name;

        if (linkType && linkType.toLowerCase() === 'contact') {
            const contact = contacts.find(contact => contact.id === rowData.entityId);
            if (contact) name = contact.name;
        } else {
            name = selectedNode.name;
        }

        return (
            <React.Fragment>
                <Tooltip
                    title={
                        <span className={classes.tooltip}>
                            {name}
                        </span>
                    }
                    placement="top-start"
                >
                    <span>{name}</span>
                </Tooltip>
            </React.Fragment>
        );
    };

    const renderMenu = link => {
        return (
            <LinksTableRowMenu
                hidden={!isFullArchitectAllowed}
                link={link}
                onToggleDeleteLinkModal={onToggleDeleteLinkModal}
            />
        );
    };

    const renderBobNamePanel = rowData => {
        if (linkType && linkType.toLowerCase() === 'contact') {
            const contact = contacts.find(contact => contact.id === rowData.entityId);

            if (contact) return contact.name;
        }

        return selectedNode.name;
    };



    const DataPanel = ({ rowData }) => {
        return (
            <div className={classes.dataPanel}>
                <div className={classes.dataColumns}>
                    <div className={classes.column}>
                        <div className={classes.row}>
                            <div className={classes.label}>
                                BOB {entityType}
                            </div>
                            <div className={classes.rowData}>
                                {renderBobNamePanel(rowData)}
                            </div>
                        </div>
                        <div className={classes.row}>
                            <div className={classes.label}>
                                BOB {entityType} ID
                            </div>
                            <div className={classes.rowData}>
                                {selectedNode.id}
                            </div>
                        </div>
                    </div>
                    <div className={classes.column}>
                        <div className={classes.row}>
                            <div className={classes.label}>
                                External {entityType}
                            </div>
                            <div className={classes.rowData}>
                                {renderLinkName(rowData)}
                            </div>
                        </div>
                        <div className={classes.row}>
                            <div className={classes.label}>
                                External {entityType} ID
                            </div>
                            <div className={classes.rowData}>
                                {rowData.externalId}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className={classes.LinksTable}>
            <MaterialTable
                options={{
                    paging:    false,
                    showTitle: false,
                    search:    false,
                    selection: false,
                    toolbar:   false,
                    sorting:   true
                }}
                columns={[
                    {
                        title:  'Integration',
                        render: rowData => renderTypeCell(rowData)
                    },
                    {
                        title:  `BOB ${entityType}`,
                        render: rowData => renderBobEntity(rowData)
                    },
                    {
                        title:  `External ${entityType}`,
                        render: rowData => renderLinkName(rowData)
                    },
                    {
                        title:  '',
                        render: rowData => renderMenu(rowData)
                    }
                ]}
                data={links}
                detailPanel={rowData => <DataPanel rowData={rowData} />}
            />
        </div>
    );
};

LinksTable.defaultProps = {
    links:                   [],
    isFullArchitectAllowed:  true,
    onSort:                  () => {},
    onToggleDeleteLinkModal: () => {}
};

LinksTable.propTypes = {
    links:                   array,
    companyInfo:             object,
    isFullArchitectAllowed:  bool,
    onSort:                  func,
    onToggleDeleteLinkModal: func
};

const mapStateToProps = state => {
    const {
        contacts,
        order,
        orderBy: orderByKey
    } = state.architect;

    return {
        order,
        orderBy:  orderByKey,
        contacts: orderBy(contacts, [orderByKey], order)
    };
};

export default connect(mapStateToProps, null)(LinksTable);
